import { useEffect, useState } from "react";

import KriterModulBilesenlerComponent from "./KriterModulBilesenlerComponent";

import KriterKomponentBilesenlerComponent from "./KriterKomponentBilesenlerComponent";
import KriterModulservice from "../../../service/Ebasvuru/AdayDomain/KriterModulService";
import { useShareContext } from "./BasvuruContext";


const ModullerComponent = ({ modulId, moduleName }) => {

    const [modul, setModul] = useState([]);



    useEffect(() => {

        if (modulId) {
            KriterModulservice.fullGet({
                filter: { id: modulId, aktif: true }
            }).then((res) => {
                if (res && res.isSuccess) {

                    setModul(res.resultObject);
                }
            });
        }
    }, [modulId]);





    const renderModul = (item) => {
        if (!item) return null;

        if (item?.kriterKomponent) {
            return <KriterKomponentBilesenlerComponent
                key={item.id}
                modulId={item.id}
                kriterKomponent={item.kriterKomponent}
                moduleName={moduleName}
            />;
        }

        return <KriterModulBilesenlerComponent
            key={item.id}
            modulId={item.id}
            moduleName={moduleName} />;
    };

    return (
        <>
            {modul.map((m) => renderModul(m))}
        </>
    );
};

export default ModullerComponent;
